import {Component, EventEmitter, Input, Output} from '@angular/core';
import {OrderEntry} from '@spartacus/cart/base/root/models/cart.model';

@Component({
  selector: 'dcp-edit-cart-page',
  templateUrl: './edit-cart-page.component.html',
  styleUrls: ['./edit-cart-page.component.scss']
})
export class EditCartPageComponent {

  configureServiceError: boolean = false;
  @Input() cartEntry: OrderEntry;
  @Input() isModalOpened: boolean;
  @Input() forceModal: boolean = false;
  @Output() addedToCart: EventEmitter<void> = new EventEmitter<void>();
  @Output() finishedLoading: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() triggerClose: EventEmitter<void> = new EventEmitter<void>();

  processConfigureServiceError(e: boolean): void {
    this.configureServiceError = e;
  }
}
